<template lang="html">
  <v-container text-xs-center>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>Services</h1>
      </v-flex>
      <v-flex class="hidden-md-and-down" pa-1 xs4 v-for="(service,index) in services" :key="index">
        <v-card>
          <v-img :src="service.image" :lazy-src="service.image" aspect-ratio="1.5">
            <template v-slot:placeholder>
              <v-layout fill-height align-center justify-center ma-0>
                <v-progress-circular indeterminate color="grey darken-5"></v-progress-circular>
              </v-layout>
            </template>
          </v-img>
          <v-card-title primary-title>
            <h3 class="headline">{{service.title}}</h3>
          </v-card-title>
        </v-card>
      </v-flex>
      <v-flex class="hidden-md-and-up" pa-1 xs6 v-for="(service,index) in services" :key="index + 4">
        <v-card>
          <v-img :src="service.image" aspect-ratio="1.5"></v-img>
          <v-card-title primary-title>
            <h3 class="subheading">{{service.title}}</h3>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      services: [{
          title: 'Music Classes',
          image: 'https://firebasestorage.googleapis.com/v0/b/sarithasangeetham-123.appspot.com/o/vocal%20class%202.jpg?alt=media&token=b466b2c4-7485-449e-85fd-be73e667bd91',
          description: ''
        },
        {
          title: 'Live Performances',
          image: 'https://firebasestorage.googleapis.com/v0/b/sarithasangeetham-123.appspot.com/o/live%20performance%202.jpeg?alt=media&token=0b806bbe-5923-4d45-9c8c-b88900effced',
          description: ''
        },
        {
          title: 'Music Composition',
          image: 'https://firebasestorage.googleapis.com/v0/b/sarithasangeetham-123.appspot.com/o/music%20composition.jpeg?alt=media&token=efaf49f0-d0b3-45ec-9e32-7bc026a0376c',
          description: ''
        }
      ]
    }
  }
}
</script>

<style lang="css" scoped>

</style>
